import { createContext, useContext } from 'react';

import useStickyState from './useStickyState';

export interface AuthenticationData {
	email: string | null
	firstName?: string | null
	imageId?: string | null
	lastName?: string | null
	refreshToken: string | null
	rocketAuthToken: string | null
	rocketUserId: string | null
	token: string | null
	userId: string | null
}

export interface User {
	firstName: string
	lastName: string
}

export const AuthenticationDataContext = createContext(null);

const initialData: AuthenticationData = {
	email: null,
	firstName: null,
	imageId: null,
	lastName: null,
	refreshToken: null,
	rocketAuthToken: null,
	rocketUserId: null,
	token: null,
	userId: null,
};
/**
 * @description Props authentication data provider
 * @param props 
 * @returns  
 */
const AuthenticationDataProvider = (props: any) => {
	const [ data, setData ] = useStickyState(initialData, 'authenticationData'); // user info, maybe permissions
	const [ isRocketIframeAuthenticated, setIsRocketIframeAuthenticated ] = useStickyState(null, 'isRocketIframeAuthenticated'); // user info, maybe permissions
	
	const deleteData = () => {
		localStorage.removeItem('tokenRefreshing');
		setData(initialData);
		setIsRocketIframeAuthenticated(null);
	}

	const getFullName = () => {
		const { firstName, lastName } = data;
		return `${firstName} ${lastName}`;
	}
	const setFullName = (firstName: string, lastName: string) => {
		setData({...data, firstName, lastName});
	}

	const setImageId = (imageId: string) => {
		setData({...data, imageId: imageId});
	}

	const isAuthenticated = (): boolean => {
		const { email, token } = data;

		return token && email;
	}

	return <AuthenticationDataContext.Provider value={{
		...data,
		deleteData,
		getFullName,
		isAuthenticated,
		isRocketIframeAuthenticated,
		setData,
		setFullName,
		setImageId,
		setIsRocketIframeAuthenticated,
	 }} {...props} />;
};

export const useAuthenticationDataContext = (): any => useContext(AuthenticationDataContext);

export default AuthenticationDataProvider;